import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TableFilterIcon = createIcon({
    viewBox: '0 0 20 20',
    path: (
        <Path
            d='M4.66667 11.402V9.598H15.3333V11.402H4.66667ZM2 5H18V6.848H2V5ZM8.208 16V14.152H11.792V16H8.208Z'
            fill='currentColor'
        />
    ),
})

TableFilterIcon.displayName = 'TableFilterIcon'
